export class TR {
	public static TR_SEE_ALL_MAP = 'TR_SEE_ALL_MAP';
}